module.exports = __webpack_public_path__ + "static/media/greenTheme.60e5bc4c.jpg";